import React from 'react';
import { PlusCircleIcon, SearchIcon, UsersIcon, PackageIcon, CalendarIcon, ClipboardCheckIcon } from 'lucide-react';
export const QuickActions = () => {
  const actions = [{
    icon: <PlusCircleIcon className="h-5 w-5" data-id="element-2274" />,
    label: 'New Enquiry',
    color: 'bg-blue-100 text-blue-600',
    path: '/enquiries/new'
  }, {
    icon: <UsersIcon className="h-5 w-5" data-id="element-2275" />,
    label: 'Find Customer',
    color: 'bg-purple-100 text-purple-600',
    path: '/customers'
  }, {
    icon: <PackageIcon className="h-5 w-5" data-id="element-2276" />,
    label: 'Browse Products',
    color: 'bg-amber-100 text-amber-600',
    path: '/products'
  }, {
    icon: <CalendarIcon className="h-5 w-5" data-id="element-2277" />,
    label: 'View Bookings',
    color: 'bg-green-100 text-green-600',
    path: '/bookings'
  }, {
    icon: <ClipboardCheckIcon className="h-5 w-5" data-id="element-2278" />,
    label: 'Daily Tasks',
    color: 'bg-teal-100 text-teal-600',
    path: '/tasks'
  }, {
    icon: <SearchIcon className="h-5 w-5" data-id="element-2279" />,
    label: 'Global Search',
    color: 'bg-gray-100 text-gray-600',
    path: '/search'
  }];
  return <div className="bg-white rounded-lg shadow-md p-4" data-id="element-2280">
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2281">Quick Actions</h2>
      <div className="grid grid-cols-3 gap-3" data-id="element-2282">
        {actions.map((action, index) => <button key={index} className="flex flex-col items-center justify-center p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-2283">
            <div className={`p-2 rounded-full ${action.color} mb-2`} data-id="element-2284">
              {action.icon}
            </div>
            <span className="text-xs font-medium text-gray-700" data-id="element-2285">
              {action.label}
            </span>
          </button>)}
      </div>
    </div>;
};